const application = {
    invalid_type: 'Apenas aplicações máquina a máquina podem ter funções associadas.',
    role_exists: 'O id da função {{roleId}} já foi adicionado a esta aplicação.',
    invalid_role_type: 'Não é possível atribuir uma função de tipo de utilizador a uma aplicação máquina a máquina.',
};
export default Object.freeze(application);
